import React from "react";
import {
    Layout,

    Menu} from "antd";
import MiCompAPI from "../../util/api";
// import MyEnrollment from "./MyEnrollment";
import Enrollments from "./Enrollments";
import Invitations from "../Contracts/MyInvitations";
import Quote from "./Quote";
const { Content } = Layout;
class Transactions extends React.Component {

    constructor(props) {

        super(props);
        let {Permissions,decodedToken}=this.props.userPermandMasters;
        var role = decodedToken.UserRoleName;

        this.state=
        {
            currentTab:"quotes",

        }

        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    componentDidMount = () => {

    };

    handleClick = (e) => {
        
      if(e.key==="quotes"){
        this.setState({
            isload: true,
        });
        setTimeout(() => {
            this.setState({
                isload: false,
            }); 
        }, 10);
      }
        this.setState({
            currentTab: e.key,
        });
    };

    getSelectedTabView() {
       
        switch (this.state.currentTab) {
            case "quotes":
                return !this.state.isload?
                 <Quote  {...this.props} userPermandMasters={this.props.userPermandMasters} />
                 : ""
            // case "enrolments":
            //     return <MyEnrollment {...this.props} userPermandMasters={this.props.userPermandMasters} />
                case "enrolment":
                    return <Enrollments {...this.props} userPermandMasters={this.props.userPermandMasters} />
            case "invite":
                return <Invitations {...this.props} userPermandMasters={this.props.userPermandMasters} />
            default:
                return <></>;
        }
    }
    render() {
        const { decodedToken,Permissions } = this.props.userPermandMasters;
        var role = decodedToken.UserRoleName;
        return (
            <Content>

                <div className="mi_main_div">                   
                    <Menu className="mi_general_bar" style={{width:'fit-content'}}
                        onClick={this.handleClick}
                        selectedKeys={[this.state.currentTab]}
                        mode="horizontal"                    >
                        <Menu.Item className="mi_menu_item" key="quotes">
                            Quotes
                        </Menu.Item>                     
                        {role!=="agency"&&((role === "carrier"||(Permissions[0].subscription_Type==="Standard"&&role==='broker'))||Permissions[0].subscription_Type==="Premium")?
                         <Menu.Item className="mi_menu_item" key="enrolment" >
                            Enrollments
                        </Menu.Item>:""}
                        {role === "carrier"&&
                        <Menu.Item className="mi_menu_item" key="invite" >
                            Invite Info
                        </Menu.Item>}
                    </Menu>
                    {this.getSelectedTabView()}
                </div>
            </Content>
        );
    }
}
export default Transactions;
